import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const avatars = {
  "birdy": {
    "name": "Birdee",
    "path": "/assets/kidframe/avatars/early/Birdee.png"
  },
  "cuzcuz": {
    "name": "Cuz-Cuz",
    "path": "/assets/kidframe/avatars/early/CuzCuz.png"
  },
  "floyd": {
    "name": "Floyd",
    "path": "/assets/kidframe/avatars/early/Floyd.png"
  },
  "icecream": {
    "name": "Officer Ice Cream",
    "path": "/assets/kidframe/avatars/early/OfficerIceCream.png"
  },
  "muggo": {
    "name": "Muggo",
    "path": "/assets/kidframe/avatars/early/Muggo.png"
  },
  "penelope": {
    "name": "Penelope",
    "path": "/assets/kidframe/avatars/early/Penelope.png"
  },
  "roly": {
    "name": "Roly",
    "path": "/assets/kidframe/avatars/early/Roly.png"
  },
  "tutu": {
    "name": "TuTu",
    "path": "/assets/kidframe/avatars/early/TuTu.png"
  }
};

export const randomAvatar = () => {
  const variants = Object.keys(avatars);
  const i = Math.floor(Math.random() * variants.length);
  return variants[i];
};

export const avatarPath = (avatar) => {
  if(!(avatar in avatars)) {
    return '';
  }

  if('Edu' in window && 'prefixCDN' in window.Edu) {
    return window.Edu.prefixCDN(avatars[avatar].path);
  }

  return avatars[avatar].path;
};

const Avatar = (props) => {
  const { variant, active, onClick } = props;
  const src = avatars[variant].path;

  return (
    <div className={clsx('avatar', active && 'active')}>
      <img alt="" src={window.Edu.prefixCDN(src)} onClick={() => onClick(variant)} />
    </div>
  );
};

Avatar.propTypes = {
  variant: PropTypes.oneOf(Object.keys(avatars)).isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func
};
Avatar.defaultProps = {
  active: false,
  onClick: function(){}
};

export default Avatar;
